module.exports = __webpack_public_path__ + "img/201.3af0987b.jpg";